export default __webpack_public_path__ + "0669adc2aaebd825ee7d0908ce977890.png";